import React from 'react';
import Zenshkool from './Landings/Zenshkool';
import Brogrammers from './Landings/Brogrammers';
import Edunexora from './Landings/Edunexora';
import VERSIONS from '@/assets/js/versions';

const APP_VERSION = VERSIONS[process.env.REACT_APP_VERSION];

function SignIn() {
  const renderLandingPage = () => {
    switch (APP_VERSION.brand) {
      case 'Zenshkool':
        return <Edunexora />;
      case 'Edunexora':
        return <Edunexora />;
      case 'Brogrammers':
      default:
        return <Edunexora />;
    }
  };

  return <div className="h-full">{renderLandingPage()}</div>;
}

export default SignIn;
